import "./styles/main.css";
import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";
import { createApp } from "vue";
import App from "./App.vue";
import { isProblem } from "./api/client";
import { meQuery } from "./api/me";
import { router } from "./router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (failures, error) => {
        // Don't retry answers that won't change (4xx, missing endpoints).
        if (isProblem(error) && error.status >= 400 && error.status < 500) return false;
        return failures < 2;
      },
    },
  },
});

const app = createApp(App).use(VueQueryPlugin, { queryClient }).use(router);
// Start fetching the session while the first route resolves, then mount (no flash of the wrong page).
void queryClient.prefetchQuery(meQuery);
void router.isReady().finally(() => app.mount("#app"));
